export default __webpack_public_path__ + "assets/images/52238b192817d35d561c560cae36d0c3.svg";